module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAA00lEQVR42u3TPQuCUBQG4H5kTdEetEZEENU/aGprEwpaioooIkNaoiGEpKvePrToS1AMifR270loF621w7s+w8s5Jwb7wATOHwfjl+PnK/zy3OvQD1ASDbuOBveF2EuJ3SRYc+LoYTGlFKvI1kdTLsFzcaLVQc0BfYTChBCM8fGg6OvZc1VkuxrgPHhmKPzxwKg5yW47VcYoEDtCZypXGMrY04LcbymKtEFSBOytSw8hbY3Lm3YDCbyGltFWRczLbTA4NZueZX1zJK5huOfz/6t+wG9HW7PuWgGKsAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/va.png
// module id = 954
// module chunks = 0